function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedeemed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9e3byuctva"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 22106",
    style: {
      fill: "#f79009"
    },
    d: "M0 0h80v80H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ewdn5bxcvb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 22120",
    style: {
      fill: "#f79009"
    },
    d: "M0 0h80v65.185H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "evoucher-icn",
    style: {
      clipPath: "url(#9e3byuctva)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 78456"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 78455",
    transform: "translate(0 6.914)",
    style: {
      clipPath: "url(#ewdn5bxcvb)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 65296",
    d: "M79.568 25.755a5.376 5.376 0 0 0-2.958-2.9l-1.151-.464v-7.067a5.418 5.418 0 0 0-5.423-5.4H44.552L29.963 4.039a1.552 1.552 0 0 0-2.018.851A1.541 1.541 0 0 0 28.8 6.9l7.5 3.025H14.55l2.193-5.391a2.329 2.329 0 0 1 3.027-1.276l4.72 1.9A1.544 1.544 0 1 0 25.653 2.3L20.933.4a5.437 5.437 0 0 0-7.063 2.974l-2.665 6.55H9.964a5.418 5.418 0 0 0-5.423 5.4v10.983L.4 36.486a5.392 5.392 0 0 0 2.99 7.032l1.151.464v7.067a5.418 5.418 0 0 0 5.423 5.4h4.962a1.543 1.543 0 1 0 0-3.086H9.964A2.322 2.322 0 0 1 7.64 51.05V30.742h13.815a22.093 22.093 0 0 0-7.069 10.537 1.549 1.549 0 0 0 2.98.848 19.953 19.953 0 0 1 7.44-10.083v21.32h-5.229a1.543 1.543 0 1 0 0 3.086h15.87l11.484 4.632a1.552 1.552 0 0 0 2.018-.851 1.541 1.541 0 0 0-.854-2.01L43.7 56.449h21.75l-2.193 5.391a2.331 2.331 0 0 1-3.027 1.276l-7.814-3.152a1.554 1.554 0 0 0-2.018.851 1.541 1.541 0 0 0 .855 2.01l7.814 3.152A5.434 5.434 0 0 0 66.129 63l2.665-6.55h1.242a5.418 5.418 0 0 0 5.423-5.4V40.067L79.6 29.888a5.346 5.346 0 0 0-.032-4.133m-2.84 2.974-1.269 3.118v-6.126a2.311 2.311 0 0 1 1.269 3.008m-60.895-7.022a1.75 1.75 0 0 1 1.254-.615 1.445 1.445 0 0 1 .213.016c1.283.192 3.094 1.8 4.97 4.4.438.608.877 1.265 1.309 1.961-4.055-.544-7.654-2.187-8.377-3.882-.109-.255-.364-.852.63-1.879M13.6 19.565a4.725 4.725 0 0 0-1.251 5.228 6.932 6.932 0 0 0 2.551 2.863H7.64V15.324a2.321 2.321 0 0 1 2.324-2.314h14.841v10.7c-1.844-2.55-4.381-5.256-7.042-5.656a4.665 4.665 0 0 0-4.163 1.511m16.823 5.965c1.882-2.617 3.7-4.229 4.986-4.422a1.43 1.43 0 0 1 .214-.016 1.752 1.752 0 0 1 1.254.615c.994 1.027.739 1.624.63 1.88-.723 1.695-4.322 3.338-8.378 3.882.426-.685.86-1.334 1.293-1.938m7.389 2.126a6.934 6.934 0 0 0 2.548-2.863 4.725 4.725 0 0 0-1.251-5.228 4.666 4.666 0 0 0-4.162-1.508c-2.66.4-5.2 3.107-7.042 5.656V13.01h42.132a2.321 2.321 0 0 1 2.324 2.314v12.332zM27.9 32.044a19.953 19.953 0 0 1 7.44 10.083 1.547 1.547 0 0 0 .775.94 1.544 1.544 0 0 0 2.205-1.787 22.1 22.1 0 0 0-7.069-10.537h41.1v20.306a2.322 2.322 0 0 1-2.324 2.314H27.9zM4.541 40.653a2.31 2.31 0 0 1-1.269-3.008l1.269-3.119zm74.671-14.748z",
    transform: "translate(.001 -.276)",
    style: {
      fill: "#f79009"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemed);
export default __webpack_public_path__ + "static/media/redeemed.43a954a235ff3ca9f5306bf61e9a86be.svg";
export { ForwardRef as ReactComponent };